var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgPlayHead(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4.8 20"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M2.4 20C1.1 20 0 19 0 17.8V2.2C0 1 1.1 0 2.4 0s2.4 1 2.4 2.2v15.6c.1 1.2-1 2.2-2.4 2.2z",
    fillRule: "evenodd"
  })));
}
export default SvgPlayHead;